import React from 'react';
import MuiAppBar from '@mui/material/AppBar';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Box, Container, Toolbar } from '@mui/material';
import MenuRightBlock from '@ui/Blocks/Shared/NavbarBlocks/MenuRightBlock';
import MenuLeftBlock from '@ui/Blocks/Shared/NavbarBlocks/MenuLeftBlock';

export default function NavbarSection({ drawerOpen, drawerWidth, logo }) {
  const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
  })(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  }));

  return (
    <AppBar
      className="Navbar__default"
      position="fixed"
      open={drawerOpen}
      sx={{
        zIndex: 1,
        paddingLeft: drawerOpen ? 0 : '55px',
      }}>
      <Container maxWidth="xlg" className="Box__main-with-padding">
        <Toolbar sx={{ paddingLeft: '0px !important', paddingRight: '0px !important' }}>
          <MenuLeftBlock logo={logo} />
          <Box sx={{ flexGrow: 1 }} />
          <MenuRightBlock />
        </Toolbar>
      </Container>
    </AppBar>
  );
}

NavbarSection.propTypes = {
  drawerOpen: PropTypes.bool,
  drawerWidth: PropTypes.number,
  logo: PropTypes.string,
};

NavbarSection.defaultProps = {
  drawerOpen: true,
  drawerWidth: 240,
  logo: null,
};
